export function normalizeAffiliateCode(code: string | null | undefined): string {
  return (code ?? '').trim().toUpperCase();
}
